import { observable } from 'mobx';

class AccreditationStore {
  @observable descriptions = null;
}

export default new AccreditationStore();
